module.exports = __webpack_public_path__ + "img/newsLogo6.c1c47286.png";